import SendFormModal from './views/main.c';
export default SendFormModal;
